<template>
    <div class="oldInnerWrapper tabContent" id="bilder1">

        <div class="oldSmallImageOuterContainer clearfix">
        
            <div v-for="(element, index) in listElement.elements" :key="element.resource" class="oldTableContainer oldSmallImageContainer">
                <div class="tableRow">
                    <div class="tableCell textAlignCenter verticalAlignMiddle">
                        <img v-if="element.url" :src="element.url" />
                    </div>
                </div>
                <div class="oldDeleteImageButton" @click.prevent="listElement.elements.splice(index, 1)"><i class="fa fa-2x fa-close"></i></div>
            </div><!-- oldSmallImageContainer -->

            <div v-for="(file, index) in files" :key="file.id" :class="['oldTableContainer', 'oldSmallImageContainer',  file.size> 1024*1024?'error':'temp',
             file.name.length > 255 ? 'error' : 'temp',
             file.error ? 'error' : 'temp']">
                <div class="tableRow">
                    <div class="tableCell textAlignCenter verticalAlignMiddle">
                        <img v-if="file.thumb" :src="file.thumb" />
                    </div>
                </div>
                <div class="oldDeleteImageButton" @click.prevent="$refs.upload.remove(file)"><i class="fa fa-2x fa-close"></i></div>
                <div v-if="file.active || file.progress !== '0.00'" class="progress old-progress">
                    <div class="progress-bar" role="progressbar" :style="{width: file.progress + '%'}" :aria-valuenow="{width: file.progress + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div v-if="file.size > 1024 * 1024" class="oldImageError">
                    Bild max 1MB
                </div>
                <div v-if="file.name.length > 255" class="oldImageError">
                    Dateiname zu lang
                </div>
            </div><!-- oldSmallImageContainer -->
        
            <div :class="['oldTableContainer', 'oldSmallImageContainer', 'dropzone', {'active': $refs.upload && $refs.upload.dropActive}]">
                <div class="tableRow">
                    <div class="tableCell textAlignCenter verticalAlignMiddle">
                        <div>
                            <i class="fa fa-picture-o fa-2x"></i>
                        </div>
                        <div>
                            Dein Bild
                        </div>
                    </div>
                </div>
            </div><!-- oldSmallImageContainer -->

        </div><!-- oldSmallImageOuterContainer -->

        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          name="image"
          style="margin-top:20px"
          class="btn btn-white teaserButton width100"
          post-action="/upload/image"
          :drop="drop"
          :multiple="multiple"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload">
          Bilder hinzufügen
        </file-upload>

        <hr/>
        

        <div class="textAlignRight buttonBlockContainerRight">
            <button type="button" v-on:click="cancel" class="btn btn-white teaserButton width50">Abbrechen</button>
            <button type="button" v-on:click="save" class="btn btn-white teaserButton width50" :disabled="uploadHasErrors()">Speichern</button>
        </div>
    </div><!-- end bilder1 -->
</template>

<script>
    import FileUpload from 'vue-upload-component'
	export default {
		name: 'userContentImages',
		props: {
            project: String,
            contentkey: String
        },
        data: function() {
        	return {
                inSave: false,
                files: [],
                multiple: true,
                directory: false,
                drop: true,
                dropDirectory: true,
                thread: 3,
                edit: false,
                minSize: 1024,
                size: 1024 * 1024,
                uploadAuto: true,
                name: 'image',

                listElement: {
                    id: null,
                    kind: 'list',
                    type: 'imageslist',
                    elements: []
                },
                model: {
                    id: null,
                    type: 'images',
                    elements: []
                }
        	}
        },
        created: function() {
            this.model.elements.push(this.listElement);
            if (this.contentkey) {
                this.loadByKey();
            } else {
                this.loadByType();
            }
        },
        methods: {
            cancel: function() {
                console.log('cancel clicked');
                this.$emit('cancel');
                return false;
            },
            loadByKey: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/' + self.contentkey,
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        self.model = data;
                        self.listElement = self.model.elements[0];
                    },
                    error: function() {alert("error");}
                });
            },
            loadByType: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/contents/images',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        if (Array.isArray(data) && data.length > 0) {
                            self.model = data[0];
                            self.listElement = self.model.elements[0];
                            console.log('load by type');
                            console.log(self.model);
                        }
                    },
                    error: function() {alert("error");}
                });
            },
            uploadHasErrors: function(error) {
                var hasErrors = false;
                this.files.forEach(function(file) {
                	console.log(file);
                    if (file.error) {
                        hasErrors = true;
                    }
                });
                return hasErrors;
            },
            save: function() {
                if (this.inSave) {
                    return;
                }
                if (this.uploadHasErrors()) {
                	console.log(this.upload.errors);
                    return;
                }
                this.inSave = true;
                var self = this;
                var selfModel = jQuery.extend(true, {}, this.model); 
                this.files.forEach(function(file) {
                    if (file.success && file.response && file.response.id) {
                        var imageElement = {
                            id: null,
                            kind: 'image',
                            type: 'imagesimage',
                            resource: file.response.id
                        }
                        selfModel.elements[0].elements.push(imageElement);
                    }
                });
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(selfModel),
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                    	console.log(data);
                        window.location.href = '/project/' + self.project + '/content.html';
                    },
                    error: function() {
                        self.inSave = false;
                        alert("error");
                    }
                });
            },
            inputFile(newFile, oldFile, prevent) {
                if (newFile && oldFile) {
                    // update
                    if (newFile.active && !oldFile.active) {
                    // beforeSend
                        // min size
                        if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                            this.$refs.upload.update(newFile, { error: 'size' })
                        }
                        // max size
                        if (newFile.size >= 0 && this.size > 0 && newFile.size > this.size) {
                            this.$refs.upload.update(newFile, { error: 'size' })
                        }
                    }
                    if (newFile.progress !== oldFile.progress) {
                    // progress
                    }
                    if (newFile.error && !oldFile.error) {
                    // error
                    }
                    if (newFile.success && !oldFile.success) {
                    // success
                    }
                }
                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        //TODO: support deletion of unreferenced s3 content
                    // $.ajax({
                    //   type: 'DELETE',
                    //   url: '/upload/delete?id=' + oldFile.response.id,
                    // })
                    }
                }
                // Automatically activate upload
                if (newFile && !oldFile && this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent()
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    // Create a blob field
                    newFile.blob = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    // Thumbnails
                    newFile.thumb = ''
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                    }
                }
            }
        },
        components: { FileUpload }
	}
</script>


// WEBPACK FOOTER //
// UserContentImages.vue?8f553232